/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { CardBody } from "../page-skeleton/CardBody";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../colors";
import React from "react";

const additionalCardBodyStyling = css`
  padding-bottom: 24px;
  padding-top: 8px;
  align-items: center;
`;

type Props = {
  children: React.ReactNode;
};

export const CardTableEmptyPlaceholder = ({ children }: Props) => {
  return (
    <CardBody css={additionalCardBodyStyling}>
      <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
        {children}
      </StyledText>
    </CardBody>
  );
};
